import i from "./isArray.js";
import o from "./_isKey.js";
import s from "./_stringToPath.js";
import a from "./toString.js";
var m = i, n = o, f = s, p = a;
function _(r, t) {
  return m(r) ? r : n(r, t) ? [r] : f(p(r));
}
var c = _;
export {
  c as default
};
//# sourceMappingURL=_castPath.js.map
